import { Check } from "lucide-react";

import type { PaymentMethodDescription as PaymentMethodDescriptionData } from "@/api-v3";

interface PaymentMethodDescriptionProps {
  /** Referenced by the radio's `aria-describedby`. */
  id: string;
  description: PaymentMethodDescriptionData;
}

/**
 * Localized copy PASS attaches to a payment method: an optional leading
 * sentence, then the selling points as a checkmarked list.
 */
export const PaymentMethodDescription = ({
  id,
  description,
}: PaymentMethodDescriptionProps) => {
  const items = description.items ?? [];
  if (!description.text && items.length === 0) return null;

  return (
    <div
      id={id}
      className="flex flex-col gap-y-1 text-sm text-muted-foreground"
    >
      {description.text && <p>{description.text}</p>}
      {items.length > 0 && (
        <ul className="flex flex-col gap-y-1">
          {items.map((item) => (
            <li key={item} className="flex items-start gap-x-1.5">
              <Check
                className="mt-0.5 size-4 shrink-0 text-primary"
                aria-hidden
              />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
